import { FC, HTMLAttributes } from "react";

import LocalImages from "../../../../assets/images/local-images";
import Content, { ContentNS } from "../../../../content/content";
import ChecklistItem, {
  InfoItem,
} from "../../../../models/checklist/checklist-item/checklist-item";
import Body from "../../../shared/styles/typography/Body.styled";
import { Summary } from "../../../shared/styles/typography/Summary.styled";
import StatusLine from "../card/components/status-line/StatusLine";
import useMergedStatus from "../card/hooks/useMergedStatus";
import { capitalizeTitle } from "utils";
import CardContent from "./styles/CardContent.styled";
import StatusLineWrapper from "./styles/StatusLineWrapper.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import StyledResolvedCard from "./styles/StyledResolvedCard-APP_CLIENT.styled";

interface CardProps extends HTMLAttributes<HTMLElement> {
  item: ChecklistItem;
}

const ResolvedCard: FC<CardProps> = ({ item }) => {
  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.checklist });

  const status = useMergedStatus(item);

  return (
    <StyledResolvedCard>
      <CardContent>
        <StatusLineWrapper>
          <StatusLine status={status} isInfo={item instanceof InfoItem} />
        </StatusLineWrapper>
        <Summary>{capitalizeTitle(item.title)}</Summary>

        <Body>{text(`card.done`)}</Body>
        <img
          className="done-image"
          src={LocalImages.shared.images.doneCard}
          alt="done"
        />
      </CardContent>
    </StyledResolvedCard>
  );
};

export default ResolvedCard;
